import { getItemFromPersistentStore, clearPersistentStore, setItemInPersistentStore } from '../utils/Persist';
import * as types from '../actionTypes';

export const signoutUserOnAuthenticationFail = (payload, data) => {
  const { history, type, onSuccess } = payload;
  const language = getItemFromPersistentStore('language');
  const messages = getItemFromPersistentStore('messages');
  const coachMarkApiFetched = getItemFromPersistentStore('coachMarkApiFetched');
  clearPersistentStore();
  if (language) setItemInPersistentStore('language', language);
  if (messages) setItemInPersistentStore('messages', messages);
  if (coachMarkApiFetched) setItemInPersistentStore('coachMarkApiFetched', coachMarkApiFetched);
  if (!type || type !== 'sso') {
    history && history.push('/');
  } else if (onSuccess) {
    onSuccess(data);
  }
  return {
    type: types.SIGNOUT_USER_ON_AUTHENTICATION_FAIL,
    payload: null
  };
}
